export const SELECT_OPTIONS = ['active', 'pending', 'consumed'] as const;
